<template>
  <router-link
    :to="{
      name: 'menu',
      hash: `#${slug(name.replace(/^\d/, 'abc$&'))}`,
    }"
  >
    <v-img
      :alt="name"
      :width="imageWidth"
      height="165"
      :src="src || ''"
      :class="getDefaultImage()"
    >
      <v-card-title
        class="flex-nowrap font-weight-bold menu-category-header-background py-2 primary--text"
      >
        <div class="text-truncate">{{ name }}</div>
        <v-icon color="primary">mdi-chevron-right</v-icon>
      </v-card-title>
    </v-img>
  </router-link>
</template>

<script>
import { mapState } from "vuex";
import { slug } from "github-slugger";
const MAX_IMAGE_WIDTH_FOR_XS_BREAKPOINT = 415;

export default {
  name: "Menu",
  data() {
    return {
      maxImageWidth:
        window.innerWidth < MAX_IMAGE_WIDTH_FOR_XS_BREAKPOINT
          ? window.innerWidth
          : MAX_IMAGE_WIDTH_FOR_XS_BREAKPOINT,
    };
  },
  methods: {
    getDefaultImage() {
      if (!this.src) {
        if (this.name == "Specials") {
          return "menu-specials-svg";
        } else if (this.storeInfo.menu_as_featured) {
          return "featured-svg";
        } else {
          return "menu-svg";
        }
      }
    },
    slug,
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
    imageWidth() {
      const smOnlyWidth = 240;
      const mdAndUpWidth = 360;

      return this.$vuetify.breakpoint.xsOnly
        ? this.maxImageWidth
        : this.$vuetify.breakpoint.smOnly
        ? smOnlyWidth
        : mdAndUpWidth;
    },
  },
  props: { name: String, src: String },
};
</script>

<style scoped>
.menu-category-header-background {
  background: rgba(255, 255, 255, 0.75);
}

.menu-svg {
  background: url(~@/assets/ic-menu.svg) no-repeat center center;
  height: 165px;
}

.featured-svg {
  background: url(~@/assets/ic-featured.svg) no-repeat center center;
  height: 165px;
}

.menu-specials-svg {
  background: url(~@/assets/ic-menu-specials.svg) no-repeat center center;
}
</style>
